import { FloatingInputProps } from "@/components/Inputs/FloatingInput/FloatingInputProps.ts";
import { FocusEvent, useState } from "react";
import { useTranslation } from "react-i18next";

export const FloatingInput = (props: FloatingInputProps) => {
  const {
    label,
    registration,
    value,
    error,
    placeholder,
    type = "text",
    required,
    icon,
    multiline,
    rows,
    maxLength,
    disabled,
    id,
    className,
    autoComplete,
  } = props;
  const [focused, setFocused] = useState(false);
  const [autofilled, setAutofilled] = useState(false);
  const { t } = useTranslation();

  const isFloating = focused || !!value || autofilled;

  const rootClasses = [
    "c-floating-input",
    isFloating && "c-floating-input--floating",
    focused && "c-floating-input--focused",
    error && "c-floating-input--error",
    icon && "c-floating-input--has-icon",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const handleFocus = () => setFocused(true);
  const handleBlur = (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFocused(false);
    void registration.onBlur(e);
  };
  const handleAnimationStart = (e: { animationName: string }) => {
    if (e.animationName === "onAutoFillStart") setAutofilled(true);
    else if (e.animationName === "onAutoFillCancel") setAutofilled(false);
  };

  const inputProps = {
    ...registration,
    id: id || registration.name,
    className: "c-floating-input__field",
    placeholder: placeholder || label,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onAnimationStart: handleAnimationStart,
    disabled,
    maxLength,
    autoComplete,
  };

  return (
    <div className={rootClasses}>
      <label className="c-floating-input__label" htmlFor={id || registration.name}>
        {label}
        {required && ""}
      </label>
      {icon && <span className="c-floating-input__icon">{icon}</span>}
      {multiline ? <textarea {...inputProps} rows={rows} /> : <input {...inputProps} type={type} />}
      {error && error.type !== "required" && (
        <span className="c-floating-input__error">
          {error.type === "maxLength" && t("form.maxLength")}
          {error.message && `${error.message}`}
        </span>
      )}
    </div>
  );
};
